export default __webpack_public_path__ + "static/media/play02.3e95ed19.svg";